import React, { RefObject } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { OverlayPanel } from 'primereact/overlaypanel';
import { FormEvent } from 'primereact/ts-helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import {
  PeriodoModo,
  StatusFilterValue,
  StatusOption,
  PERIODO_OPTIONS,
  STATUS_OPTIONS,
} from './constants';

interface IntegrationErrorsFiltersProps {
  isAplicarDisabled: boolean;
  onAplicarPeriodo: () => void;
  onClearPeriodo: () => void;
  onClearSearch: () => void;
  onOverlayShow: () => void;
  onPeriodoCustomChange: (event: FormEvent<(Date | null)[]>) => void;
  onPeriodoModoClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onPeriodoOverlayToggle: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onSearchTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusFilterChange: (event: DropdownChangeEvent) => void;
  periodoAplicadoAtivo: boolean;
  periodoCustomDraft: Date[];
  periodoLabel: string;
  periodoModoDraft: PeriodoModo;
  periodoOverlayRef: RefObject<OverlayPanel>;
  statusFilter: StatusFilterValue;
  textInput: string;
}

const statusValueTemplate = (option: StatusOption | null) =>
  !option || option.value === 'todos' ? (
    <span className="filter-status-placeholder">Status</span>
  ) : (
    <span>{option.label}</span>
  );

const IntegrationErrorsFilters: React.FC<IntegrationErrorsFiltersProps> = ({
  isAplicarDisabled,
  onAplicarPeriodo,
  onClearPeriodo,
  onClearSearch,
  onOverlayShow,
  onPeriodoCustomChange,
  onPeriodoModoClick,
  onPeriodoOverlayToggle,
  onSearchTextChange,
  onStatusFilterChange,
  periodoAplicadoAtivo,
  periodoCustomDraft,
  periodoLabel,
  periodoModoDraft,
  periodoOverlayRef,
  statusFilter,
  textInput,
}) => (
  <div className="panel-filters">
    <div className="filter-input-wrapper">
      <input
        type="text"
        placeholder="Filtrar"
        value={textInput}
        onChange={onSearchTextChange}
      />
      {textInput && (
        <button
          type="button"
          className="filter-clear-btn"
          onClick={onClearSearch}
          aria-label="Limpar busca"
        >
          <i className="pi pi-times" />
        </button>
      )}
    </div>

    <button
      type="button"
      className={`filter-periodo-dropdown${
        periodoAplicadoAtivo ? ' filter-periodo-dropdown--active' : ''
      }`}
      onClick={onPeriodoOverlayToggle}
    >
      <span className="filter-btn-label">{periodoLabel}</span>
      <FontAwesomeIcon icon={faCaretDown} className="filter-btn-icon" />
    </button>
    <OverlayPanel
      ref={periodoOverlayRef}
      className="periodo-overlay"
      dismissable
      onShow={onOverlayShow}
    >
      <div className="periodo-overlay-content">
        <div className="periodo-opcoes">
          {PERIODO_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              value={option.value}
              className={`periodo-opcao-btn${
                periodoModoDraft === option.value
                  ? ' periodo-opcao-btn--active'
                  : ''
              }`}
              onClick={onPeriodoModoClick}
            >
              {option.label}
            </button>
          ))}
        </div>

        {periodoModoDraft === 'customizado' && (
          <>
            <p className="periodo-overlay-label">Selecione o intervalo</p>
            <Calendar
              value={
                periodoCustomDraft.length > 0 ? periodoCustomDraft : undefined
              }
              onChange={onPeriodoCustomChange}
              selectionMode="range"
              inline
              dateFormat="dd/mm/yy"
              showButtonBar={false}
            />
          </>
        )}

        <div className="periodo-overlay-actions">
          <button
            type="button"
            className="p-button p-component p-button-text p-button-sm"
            onClick={onClearPeriodo}
          >
            <span className="p-button-label p-c">Limpar</span>
          </button>
          <button
            type="button"
            className="p-button p-component p-button-sm"
            onClick={onAplicarPeriodo}
            disabled={isAplicarDisabled}
          >
            <span className="p-button-label p-c">Aplicar</span>
          </button>
        </div>
      </div>
    </OverlayPanel>

    <Dropdown
      value={statusFilter}
      options={STATUS_OPTIONS}
      onChange={onStatusFilterChange}
      valueTemplate={statusValueTemplate}
      dropdownIcon={<FontAwesomeIcon icon={faCaretDown} />}
      className="filter-status-dropdown"
      panelClassName="filter-status-panel"
      appendTo={document.body}
    />
  </div>
);

export default React.memo(IntegrationErrorsFilters);
